// import Rx from 'rxjs/Rx';

import {Reducer} from 'redux';
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {PledgerAction} from "@pledger/frontend-commons";
import {FooterType} from "../app/FooterType";
import {
    CaptchaToken,
    VerifyCaptcha
} from "@pledger/frontend-commons/dist/ui/components/reCaptcha/ReCaptchaContainedProps";
import {ContactActions} from "./ContactActions";
import {WServiceActions} from "../../services/ws/WServiceActions";


/**
 * Reducers de la page Home.
 *
 * Les donnée d'affichage de lapage Home sont fixes, ce qui explique
 * l'abscence d'epics de chargement spécifiques.
 *
 * @module front/reducers/HomeReducers
 */


const footerType = (state = FooterType.LARGE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.LARGE;
    }
};

const email = (state = '', action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.CONTACT_CHANGE_EMAIL_ACTION.type:
            return action.payload.email;
        default:
            return state;
    }
};

const validEmail = (state = true, action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.CONTACT_CHANGE_EMAIL_ACTION.type:
            return true;
        case ContactActions.CONTACT_INVALID_EMAIL_ACTION.type:
            return false;
        default:
            return state;
    }
};

const phoneNumber = (state = '', action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.CONTACT_CHANGE_PHONENUMBER_ACTION.type:
            return action.payload.phoneNumber;
        default:
            return state;
    }
};

const validPhoneNumber = (state = true, action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.CONTACT_CHANGE_PHONENUMBER_ACTION.type:
            return true;
        case ContactActions.CONTACT_INVALID_PHONENUMBER_ACTION.type:
            return false;
        default:
            return state;
    }
};


const captchaInvalid = (state :  boolean | string  = '', action: PledgerAction) => {
    switch (action.type) {
        case WServiceActions.REGISTER_CONTACT_SUCCEEDED_ACTION.type: {
            const captchaInvalid = action.payload.data.captchaResult !== true;
            if (captchaInvalid) {
                console.log("captchaInvalid : " + captchaInvalid)
            }

            return captchaInvalid;
        }
        case ContactActions.UPDATE_CAPTCHA_ACTION.type: {
            const captchaInvalid = !action.payload.captchaReady;
            if (captchaInvalid) {
                console.log("captchaInvalid : " + captchaInvalid)
            }

            return captchaInvalid;
        }
        case ContactActions.REGISTER_INVALID_CAPTCHA.type: {
            const captchaInvalid = true;
            if (captchaInvalid) {
                console.log("captchaInvalid : " + captchaInvalid)
            }
            return captchaInvalid;
        }

        default:
            return state;
    }
}
const verifyCaptcha = (state : VerifyCaptcha | string = '', action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.UPDATE_CAPTCHA_ACTION.type:
            return action.payload.verifyCaptcha ?? '';

        default:
            return state;
    }
}

const captchaReady = (state = false, action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.UPDATE_CAPTCHA_ACTION.type:
            return action.payload.captchaReady;

        default:
            return state;
    }
}

const captchaToken = (state : CaptchaToken = {}, action: PledgerAction) => {
    switch (action.type) {
        case ContactActions.UPDATE_CAPTCHA_TOKEN_ACTION.type:
            return action.payload.captchaToken;

        default:
            return state;
    }
}


export interface ContactPageComponentState extends PledgerPageComponentState {
    email: string;
    validEmail: boolean;
    phoneNumber:string;
    validPhoneNumber: boolean;
    captchaInvalid:boolean | string;
    verifyCaptcha : VerifyCaptcha | string;
    captchaReady:boolean;
    captchaToken:CaptchaToken;
}

export const contact : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action),
        email:email(state.email,action),
        validEmail:validEmail(state.validEmail,action),
        phoneNumber: phoneNumber(state.phoneNumber, action),
        validPhoneNumber:validPhoneNumber(state.validPhoneNumber,action),
        captchaInvalid: captchaInvalid(state.captchaInvalid, action),
        verifyCaptcha: verifyCaptcha(state.verifyCaptcha, action),
        captchaReady: captchaReady(state.captchaReady, action),
        captchaToken: captchaToken(state.captchaToken, action),
    }
}
